namespace Q {

    // inspired from https://github.com/premasagar/tim

    var start = "{{",
        end = "}}",
        path = "[a-z0-9_$][\\.a-z0-9_]*", // e.g. config.person.name
        pattern = new RegExp(start + "\\s*(" + path + ")\\s*" + end, "gi"),
        undef;

    function nop(s: any) {
        return s == null ? '' : s;
    }

    export function microFormat(template: string, data: any, options?: microFormatOptions) {

        var encoder = options != null && options.htmlEncode ? Q.attrEncode : nop;
        var basic = options == null || !options.dotAccess;
        if (data == null)
            data = {};

        return template.replace(pattern, function (tag, token, offset) {

            if (options != null && options.handler != null) {
                var result = options.handler(token, data, offset, template);
                if (result !== undef) {
                    return encoder(result);
                }
            }

            if (basic) {
                return encoder(data[token]);
            }

            var path = token.split("."),
                len = path.length,
                lookup = data,
                i = 0;

            for (; i < len; i++) {
                lookup = lookup[path[i]];

                if (lookup === undef) {
                    return '';
                }

                // Return the required value
                if (i === len - 1) {
                    return encoder(lookup);
                }
            }
        });
    }

    export interface microFormatOptions {
        handler?: (token: string, data: any, offset: number, str: string) => string | void
        dotAccess?: boolean;
        htmlEncode?: boolean;
    }
}